// Angular
import { Component, OnDestroy, OnInit } from '@angular/core';
// Service
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { SignalRService } from '../../../signal-r/service/signal-r.service';
import { GlobalUtils } from '../../../utils/global.utils';
// Model
// Other
import { Store } from '@ngxs/store';
import { Subject } from 'rxjs';
import { AUTHMESSAGE } from '../../../model/role.model';

const AUTH_FAIL = 'You are not logged into our system';

@Component({
	selector: 'cv-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
	public today: number = Date.now();
	submitted = false;
	isLoading: boolean;
	returnUrl: string;
	authFailure: boolean;
	authFailMsg = AUTH_FAIL;
	showButton = true;
	public isInsideIframe = GlobalUtils.isInsideIframe();

	private atComponentDestroy = new Subject();

	constructor(
		private signalRService: SignalRService,
		private oidcSecurityService: OidcSecurityService,
		private store: Store
	) {
		this.signalRService.stopConnection();
	}

	/**
	 * On submit.
	 */
	onSubmit(): void {
		this.oidcSecurityService.authorize();
	}

	ngOnInit(): void {
		const msg = this.store.selectSnapshot(state => state.user);
		if (msg.loginMessage) {
			this.authFailMsg = msg.loginMessage;

			if (this.authFailMsg === AUTHMESSAGE.TOKEN_EXPIRED) {
				this.showButton = false;
			}
		}
	}

	/**
	 * Close all when the element is destroyed
	 * in case a Sub Component remains visible
	 */
	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
